import { render, staticRenderFns } from "./Days.vue?vue&type=template&id=05b804b6&"
import script from "./Days.vue?vue&type=script&lang=js&"
export * from "./Days.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports